import State from '@/classes/state';
import productFilterAppData from '@/utility/product-filter-app-data';

if (!productFilterAppData) {
    throw new TypeError("Product filter app variable is not available");
}

const { config, translations, productsShop } = productFilterAppData;

if (!config) {
    throw new TypeError("Config object is not available");
}

if (!translations) {
    throw new TypeError("Translation object is not available");
}

// Create state
const state = new State({
    config,
    translations,
    products: productFilterAppData.products,
    productsShop,
    filters: productFilterAppData.filters,
    predefinedFilterItems: productFilterAppData.predefinedFilterItems,
    productSorting: config.initialSorting,
    productLimit: config.initialChunkSize || config.chunkSize,
});

export default state;
